import React from "react";
import { Link } from "react-router-dom";
import DonationSection from "../components/DonationSection";
import FireLogo from "../components/FireLogo";
import Footer from "../components/Footer";

export default function Donate() {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)]">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 hero-gradient" />
        <div
          className="absolute -top-24 left-10 h-60 w-60 rounded-full opacity-40 blur-3xl animate-float"
          style={{ backgroundColor: "var(--accent-3)" }}
        />
        <div
          className="absolute top-10 right-10 h-72 w-72 rounded-full opacity-25 blur-3xl animate-float-slow"
          style={{ backgroundColor: "var(--accent-2)" }}
        />
        <div className="hero-container relative mx-auto max-w-6xl px-4 pb-12 pt-12">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="inline-flex items-center gap-3 rounded-full bg-white/70 px-3 py-1 text-xs uppercase tracking-[0.2em] text-[var(--muted)]">
              <FireLogo size={40} data-hero-logo />
              <span>BetterBMRCalculator</span>
            </div>
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-5 py-2 text-xs font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
            >
              Back to calculator
            </Link>
          </div>
          <div className="mt-6 max-w-2xl space-y-4">
            <h1 className="text-3xl font-display leading-tight text-[var(--ink)] md:text-4xl">
              Support the roadmap.
            </h1>
            <p className="text-base text-[var(--muted)]">
              Donations help keep BetterBMRCalculator free and let you
              request new features. Every request is shared publicly so
              the roadmap stays transparent.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#donate-form"
                className="inline-flex items-center justify-center rounded-full bg-[var(--accent)] px-5 py-2 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(227,108,79,0.35)] transition hover:-translate-y-0.5"
              >
                Make a request
              </a>
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-5 py-2 text-sm font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
              >
                Go to calculator
              </Link>
              <Link
                to="/goals"
                className="inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-5 py-2 text-sm font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
              >
                Project goals
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div id="donate-form">
        <DonationSection />
      </div>
      <Footer />
    </div>
  );
}
